import React from 'react';

export const KybDescription: React.FC<KybDescriptionProps> = ({ title, description }) => {
  return (
    <div>
      <h3 className="size-24 font-weight-600">{title}</h3>
      <h4 className="size-16 font-weight-400 text-muted mb-4">{description}</h4>
    </div>
  );
};

interface KybDescriptionProps {
  title: string;
  description: string;
}
